import React, { useEffect, useRef, useState } from "react";
import CommonSelect from "../../../core/common/commonSelect";
import api from "../../../services/api";
import { showBasicAlert } from "../../../core/common/useAlert";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import Loader from "../../../core/common/loader";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import { useSelector } from "react-redux";

import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  Box,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
} from "@mui/material";
import { label } from "yet-another-react-lightbox/*";

const AddLeads = ({
  companyList,
  formsList,
  users,
  lastLeadData,
  refreshPage,
}: {
  companyList: any;
  formsList: any;
  users: any;
  lastLeadData: any;
  refreshPage: (type: any) => void;
}) => {
  const user = useSelector((state: any) => state.user.user);

  const [filteredData, setFilteredData] = useState<any[]>([]);
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const [assignedLeadType, setAssignedLeadType] = useState("Manual");

  const signature = localStorage.getItem("signature");
  var initialFormDataChooseCompany = {
    signature: signature,
    companyName: lastLeadData[0]?.company_name,
    companyId: lastLeadData[0]?.company_id,
    companyType: lastLeadData[0]?.company_type,
  };

  const [countries, setCountries] = useState<any[]>([]);

  const [statesOrignal, setStatesOrignal] = useState<any[]>([]);
  const [states, setStates] = useState<any[]>([]);

  const [citiesOrignal, setCitiesOrignal] = useState<any[]>([]);
  const [cities, setCities] = useState<any[]>([]);

  const [distOrignal, setDistOrignal] = useState<any[]>([]);
  const [districts, setDistricts] = useState<any[]>([]);

  const [pipeline, setPipeline] = useState<any[]>([]);

  const leadSource = [
    {
      value: "Direct Calling",
      label: "Direct Calling",
      children: [
        { value: "Outbound Call (Manual)", label: "Outbound Call (Manual)" },
        { value: "Inbound Call", label: "Inbound Call" },
        { value: "Inbound via Campaign", label: "Inbound via Campaign" },
      ],
    },
    {
      value: "Messaging & Campaigns",
      label: "Messaging & Campaigns",
      children: [
        { value: "SMS Campaign", label: "SMS Campaign" },
        { value: "WhatsApp Campaign", label: "WhatsApp Campaign" },
      ],
    },
    {
      value: "Referrals",
      label: "Referrals",
      children: [
        { value: "Wholesaler/Distributor", label: "Wholesaler/Distributor" },
        { value: "Past Student Referral", label: "Past Student Referral" },
        { value: "Society Referral", label: "Society Referral" },
        { value: "Department Referral", label: "Department Referral" },
        { value: "Helpdesk", label: "Helpdesk" },
      ],
    },
    {
      value: "Social Media",
      label: "Social Media",
      children: [
        { value: "Facebook", label: "Facebook" },
        { value: "Instagram", label: "Instagram" },
        { value: "WhatsApp", label: "WhatsApp" },
      ],
    },
    {
      value: "Public Form",
      label: "Public Form",
    },
  ];

  const [leadSourceData, setleadSourceData] = useState({
    parent: "",
    child: "",
  });

  // Handle changes in the parent dropdown
  const handleParentChange = (e: any) => {
    const selectedParent = e.target.value;

    // Reset child dropdown when parent changes
    setleadSourceData({
      ...leadSourceData,
      parent: selectedParent,
      child: "", // Reset child dropdown value
    });
  };

  // Handle changes in the child dropdown
  const handleChildChange = (e: any) => {
    setleadSourceData({
      ...leadSourceData,
      child: e.target.value,
    });
  };

  // Find the children based on the selected parent
  const selectedParent = leadSource.find(
    (source) => source.value === leadSourceData.parent
  );
  const childOptions = selectedParent ? selectedParent.children : [];

  useEffect(() => {
    // This will run when the component mounts
    const fetchDashboardData = async () => {
      try {
        setIsLoading(true);
        const [countryResponse, stateResponse, districtResponse, cityResponse] = await Promise.all([
          api.post("userService/getCountry", { signature }),
          api.post("userService/getState", { signature }),
          api.post("userService/getDistrict", { signature }),
          api.post("userService/getCity", { signature }),
        ]);
        setCountries(countryResponse.data.data);
        setStatesOrignal(stateResponse.data.data);
        setDistOrignal(districtResponse.data.data);
        setCitiesOrignal(cityResponse.data.data);
        setIsLoading(false);

      } catch (err: any) {
        showBasicAlert(err.data.message[0].msg);
        console.error("Error fetching dashboard data:", err);
      }
    };

    fetchDashboardData();
  }, []);

  useEffect(() => {
    const india = countries.find((c) => c.name.toLowerCase() === "india");
    if (india) {
      const defaultValue = `${india.name}-${india.id}`;
      setSelectedCountry(defaultValue);
      handleCountryChange({ target: { value: defaultValue } });
    }
  }, [countries]); // run when countries are loaded

  const [responses, setResponses] = useState<any>({});

  const [selectedCountry, setSelectedCountry] = useState("");
  const handleCountryChange = (e: any) => {
    const countryId = e.target.value;
    setSelectedCountry(countryId);
    setResponses({
      ...responses,
      Country: countryId.split("-")[0],
    });
    // Filter states based on country selection
    const filteredStates = statesOrignal.filter(
      (state) => parseInt(state.country_id) == parseInt(countryId.split("-")[1])
    );
    setStates(filteredStates);
  };

  const handleStateChange = (e: any) => {
    const stateId = e.target.value;
    setResponses({
      ...responses,
      State: stateId.split("-")[0],
    });
    const filteredCities = citiesOrignal.filter(
      (city) => parseInt(city.state_id) == parseInt(stateId.split("-")[1])
    );
    setCities(filteredCities);

    const filteredDist = distOrignal.filter(
      (dist) => parseInt(dist.state_id) == parseInt(stateId.split("-")[1])
    );
    setDistricts(filteredDist);
  };

  const handleCityChange = (e: any) => {
    const cityId = e.target.value;
    setResponses({
      ...responses,
      City: cityId.split("-")[0],
    });
  };

  const handleDistChange = (e: any) => {
    const distId = e.target.value;
    setResponses({
      ...responses,
      District: distId.split("-")[0],
    });
  };

  const [formDataCompanyChoose, setformDataCompanyChoose] = useState(
    initialFormDataChooseCompany
  );

  const companyChoose = [
    ...companyList?.map((company: any) => ({
      value: company.id,
      label: company.name + " - " + company.type,
    })),
  ];

  useEffect(() => {
    const modal = document.getElementById("add_leads");

    const handleShown = () => {
      handleCompanyChanges({
        value: companyList?.[0]?.id,
        label: companyList?.[0]?.name + "-" + companyList?.[0]?.type,
      });
    };

    if (modal) {
      modal.addEventListener("shown.bs.modal", handleShown);
    }

    return () => {
      if (modal) {
        modal.removeEventListener("shown.bs.modal", handleShown);
      }
    };
  }, [companyList]);

  const [filteredArray, setfilteredArray] = useState<any>(null);
  const [filteredArrayPiepline, setfilteredArrayPipeline] = useState<any>(null);
  const [filteredUsers, setfilteredUsers] = useState<any>(null);

  const handleCompanyChanges = async (selectedOption: any) => {
    if (!selectedOption) return;
    setfilteredFormList(null);
    const newFormData = {
      companyId: selectedOption.value,
      companyName: selectedOption.label.split("-")[0].trim(),
      companyType: selectedOption.label.split("-")[1].trim(),
    };

    setformDataCompanyChoose((prev: any) => ({
      ...prev,
      ...newFormData,
    }));

    const [getLeadSettings, getPipeline] = await Promise.all([
      api.post("leadService/getAllLeadSettings", {
        signature,
        company_id: newFormData.companyId,
        company_type: newFormData.companyType,
      }),
      api.post("leadService/getAllPipelines", {
        signature,
      }),
    ]);

    setPipeline(getPipeline.data.data.data);

    let checkUserTypeCondition = false;
    if (
      parseInt(
        getLeadSettings?.data?.data?.data[0]?.settings
          .lead_assigned_to_department
      ) == parseInt(user?.userDetails?.department)
    ) {
      checkUserTypeCondition = true;
    }
    const filteredArrayList = formsList.filter((item: any) => {
      const isMatchingCompanyType =
        item.CompanyType.toLowerCase() ===
        newFormData.companyType.toLowerCase();
      const isMatchingCompanyId =
        parseInt(item.CompanyId) === parseInt(newFormData.companyId);
      const isActive = item.Status === "Active";
      const isEmployeeIncluded = item.employees.includes(
        parseInt(user?.userDetails?.id)
      );

      return (
        isMatchingCompanyType &&
        isMatchingCompanyId &&
        isActive &&
        (checkUserTypeCondition ? isEmployeeIncluded : true)
      );
    });

    const filterFormList = [
      ...filteredArrayList?.map((list: any) => ({
        value: list.key,
        label: list.LeadFormName,
      })),
    ];
    setfilteredArray(filterFormList);
  };

  useEffect(() => {
    const matchedForm = formsList?.find(
      (item: any) => item.key === lastLeadData?.[0]?.form_id
    );

    if (matchedForm) {
      handleFilterFormChange({
        value: matchedForm.key,
        label: matchedForm.LeadFormName,
      });
    }
  }, [filteredArray]);

  useEffect(() => {
    const matchedPipeline = filteredArrayPiepline?.find(
      (item: any) =>
        item.value.toLowerCase() ==
        lastLeadData?.[0]?.pipeline_char.toLowerCase()
    );
    if (matchedPipeline) {
      handleCompanyChangesPipeline({
        value: matchedPipeline.value,
        label: matchedPipeline.label,
      });
    }

    setleadSourceData({
      ...leadSourceData,
      parent: lastLeadData?.[0]?.lead_source || "",
      child: lastLeadData?.[0]?.lead_source_child || "",
    });
  }, [filteredArrayPiepline]);

  const [filteredFormList, setfilteredFormList] = useState<any>(null);

  var initialChooseFormName = {
    leadFormName: "",
    id: "",
  };
  const [formSelectDataChoose, setformSelectDataChoose] = useState(
    initialChooseFormName
  );

  const handleFilterFormChange = (selectedOption: any) => {
    if (!selectedOption) return;

    const newSelectedLeadFormData = {
      id: selectedOption.value,
      leadFormName: selectedOption.label,
    };

    setformSelectDataChoose((prev: any) => ({
      ...prev,
      ...newSelectedLeadFormData,
    }));

    const filteredForms = formsList.filter(
      (form: any) => form.key === newSelectedLeadFormData.id
    );

    if (!filteredForms || filteredForms.length === 0 || !filteredForms[0]?.employees) {
      setfilteredUsers([{ value: "", label: "Select Employee" }]);
      setfilteredFormList(null);
      return;
    }

    const matchedEmployees = users.filter((emp: any) =>
      filteredForms[0].employees.includes(emp.key)
    );

    const filterEmployee = [
      { value: "", label: "Select Employee" },
      ...matchedEmployees.map((list: any) => ({
        value: list.key,
        label: list.Fname + " " + list.Lname,
      })),
    ];
    setfilteredUsers(filterEmployee);

    const filteredSelectedForm = formsList.filter(
      (item: any) =>
        item.LeadFormName.toLowerCase() ===
        newSelectedLeadFormData.leadFormName.toLowerCase() &&
        parseInt(item.key) === parseInt(newSelectedLeadFormData.id)
    );

    setfilteredFormList(filteredSelectedForm);

    if (!pipeline || pipeline.length === 0) {
      setfilteredArrayPipeline([]);
      return;
    }
    const pipelineList = pipeline.filter(
      (item) =>
        item.Pipeline_Name === filteredSelectedForm[0]?.Pipeline &&
        item.Type == "lead"
    );

    if (!pipelineList || pipelineList.length === 0 || !pipelineList[0]?.Stages) {
      setfilteredArrayPipeline([]);
      return;
    }
    const filterFormList = [
      ...pipelineList[0].Stages.map((list: any) => ({
        value: list,
        label: list,
      })),
    ];
    setfilteredArrayPipeline(filterFormList);
  };


  var initialChoosePipelineName = {
    pipelineName: "",
    id: "",
  };

  const [formSelectDataChoosePipeline, setformSelectDataChoosePipeline] =
    useState(initialChoosePipelineName);

  const handleCompanyChangesPipeline = async (selectedOption: any) => {
    if (!selectedOption) return;

    const newFormData = {
      pipelineName: selectedOption.value,
      id: selectedOption.value,
    };
    setformSelectDataChoosePipeline((prev: any) => ({
      ...prev,
      ...newFormData,
    }));
  };

  var initialChooseEmployee = {
    Name: "",
    id: "",
  };

  const [formSelectDataChooseEmployee, setformSelectDataChooseEmployee] =
    useState(initialChooseEmployee);

  const handleCompanyChangesEmployee = async (selectedOption: any) => {
    if (!selectedOption) return;

    const newFormData = {
      Name: selectedOption.label,
      id: selectedOption.value,
    };
    setformSelectDataChooseEmployee((prev: any) => ({
      ...prev,
      ...newFormData,
    }));
  };

  interface FormField {
    id: number;
    label: string;
    type: string;
    options?: string[];
    required: Boolean;
  }

  const handleSubmit = async () => {
    try {
      const isEmpty = (obj: any) => Object.keys(obj).length === 0;

      if (isEmpty(responses)) {
        showBasicAlert("All fields are mandatory");
        return;
      }

      var dataToSubmit: any = {
        form_id: formSelectDataChoose.id,
        response: responses,
        company_id: formDataCompanyChoose.companyId,
        company_type: formDataCompanyChoose.companyType,
        signature: formDataCompanyChoose.signature,
        lead_source: leadSourceData.parent,
        lead_source_child:
          leadSourceData.child == "" ? null : leadSourceData.child,
        priority: "High",
        assigned_lead_type: assignedLeadType,
        assigned_to:
          formSelectDataChooseEmployee.id == ""
            ? null
            : formSelectDataChooseEmployee.id,
      };
      if (formSelectDataChoosePipeline.pipelineName != "") {
        dataToSubmit["pipeline"] = formSelectDataChoosePipeline.pipelineName;
      }
      const response = await api.post(
        "leadService/addLeadRespone",
        dataToSubmit
      );
      showBasicAlert(response.data.message[0].msg);
      setfilteredFormList(null);
      refreshPage("updateUI");
    } catch (error: any) {
      showBasicAlert(error.data.message[0].msg);
    }
  };

  const [csvData, setCsvData] = useState<any[]>([]);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (result: any) => {
        setCsvData(result.data);
      },
    });
  };

  const handleRemoveFile = () => {
    setCsvData([]);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const [isLoading, setIsLoading] = useState(false);

  const uploadCsvData = async () => {
    setIsLoading(true);
    if (!csvData.length) {
      showBasicAlert("No data found in the uploaded CSV.");
      return;
    }
    setIsUploading(true);
    // Validate once before loop
    const columns = filteredFormList[0].structure.map(
      (field: any) => field.label
    );
    const isCorrectCsv = await compareArrays(columns, Object.keys(csvData[0]));

    if (!isCorrectCsv) {
      showBasicAlert("Invalid CSV");
      setIsUploading(false);
      setIsLoading(false);
      return;
    }

    const payload = csvData.map((row) => ({
      form_id: formSelectDataChoose.id,
      response: row,
      company_id: formDataCompanyChoose.companyId,
      company_type: formDataCompanyChoose.companyType,
      signature: formDataCompanyChoose.signature,
      lead_source: leadSourceData.parent,
      lead_source_child:
        leadSourceData.child == "" ? null : leadSourceData.child,
      priority: "High",
      assigned_lead_type: assignedLeadType,
      assigned_to:
        formSelectDataChooseEmployee.id == ""
          ? null
          : formSelectDataChooseEmployee.id,
      pipeline: formSelectDataChoosePipeline.pipelineName == ""
        ? null
        : formSelectDataChoosePipeline.pipelineName,

    }));



    try {
      const result = await api.post("leadService/bulkAddLeadResponse", {
        signature: formDataCompanyChoose.signature,
        leads: payload,
      });
      const duplicateLeads = result.data.message[0].duplicates || [];
      setFilteredData(duplicateLeads);
      showBasicAlert("CSV data uploaded successfully!");
      setCsvData([]);
    } catch (error) {
      console.error("Error uploading leads: ", error);
      showBasicAlert("Failed to upload CSV data");
    }

    setIsUploading(false);
    setIsLoading(false);
  };

  const compareArrays = async (arr1: any, arr2: any) => {
    const result = [];
    let i1 = 0; // index for arr1
    let i2 = 0; // index for arr2
    let allMatched = true;
    const mismatchMessages = [];

    while (i1 < arr1.length && i2 < arr2.length) {
      const value2 = arr2[i2];

      if (value2 === "Country") {
        // skip current arr1 and 4 items in arr2
        i1++;
        i2 += 4;
        continue;
      }

      const value1 = arr1[i1];
      const match = value1 === value2;

      result.push({ position: i1, label1: value1, label2: value2, match });

      if (!match) {
        allMatched = false;
        mismatchMessages.push(
          `❌ Mismatch at position ${i1}: '${value1}' (label1) ≠ '${value2}' (label2)`
        );
      }

      i1++;
      i2++;
    }
    if (allMatched) {
      return true;
    } else {
      console.error(
        "❌ Label mismatches found:\n" + mismatchMessages.join("\n")
      );
      return false;
    }
  };

  const handleExportExcel = () => {
    if (!filteredFormList?.[0]?.structure) return;

    const structure = filteredFormList[0].structure;

    const columns: string[] = [];
    const wsData: string[][] = [[]]; // initialize header row

    // Track columns that need dropdowns
    const validations: {
      col: number;
      options: string[];
    }[] = [];

    let colIndex = 0;

    structure.forEach((field: any) => {
      if (field.type === "country") {
        wsData[0].push("Country", "State", "District", "City");
        colIndex += 4;
      } else if (field.type === "select") {
        wsData[0].push(field.label);
        if (Array.isArray(field.options) && field.options.length > 0) {
          validations.push({
            col: colIndex,
            options: field.options.map((opt: any) =>
              typeof opt === "string" ? opt : opt.label
            ),
          });
        }
        colIndex += 1;
      } else {
        wsData[0].push(field.label);
        colIndex += 1;
      }
    });

    // Create sheet
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Apply dropdowns (data validation)
    validations.forEach(({ col, options }) => {
      for (let row = 2; row <= 100; row++) {
        const cellAddress = XLSX.utils.encode_cell({ r: row - 1, c: col });
        ws["!dataValidation"] = ws["!dataValidation"] || [];
        ws["!dataValidation"].push({
          type: "list",
          allowBlank: true,
          sqref: cellAddress,
          formula1: `"${options.join(",")}"`,
        });
      }
    });

    // Write workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    XLSX.writeFile(
      wb,
      (formSelectDataChoose?.leadFormName || "Export") + ".csv"
    );
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "Name",
      sorter: (a: any, b: any) => a.Name.length - b.Name.length,
    },
    {
      title: "Email",
      dataIndex: "Email",
      sorter: (a: any, b: any) => a.Email.length - b.Email.length,
    },
    {
      title: "Mobile No",
      dataIndex: "Mobile No",
      sorter: (a: any, b: any) => a["Mobile No"].length - b["Mobile No"].length,
    },
  ];

  return (
    <>
      {/* {isLoading && <Loader />} */}
      <>
        {/* Add Leads */}
        <div className="modal fade" id="add_leads">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              {filteredData.length > 0 && (
                <div className="card">
                  <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                    <h5>Duplicate Leads</h5>
                  </div>
                  <div className="card-body p-0">
                    <Table
                      key={JSON.stringify(filteredData)}
                      dataSource={filteredData}
                      columns={columns}
                      Selection={false}
                    />
                  </div>
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      setformSelectDataChoose({ leadFormName: "", id: "" });
                      setfilteredFormList(null);
                      setFilteredData([]);
                      refreshPage("cancel");
                      setCsvData([]);
                    }}>
                    Cancel
                  </button>
                </div>
              )}
              {filteredData.length == 0 && (
                <div>
                  <div className="modal-header">
                    <h4 className="modal-title">Add New Lead</h4>
                    <button
                      type="button"
                      className="btn-close custom-btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={() => {
                        setformSelectDataChoose({ leadFormName: "", id: "" });
                        setfilteredFormList(null);
                        refreshPage("cancel");
                        setCsvData([]);
                      }}>
                      <i className="ti ti-x" />
                    </button>
                  </div>

                  <form>
                    <div className="modal-body pb-0">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">
                              Company<span className="text-danger"> *</span>
                            </label>
                            <CommonSelect
                              className="select"
                              options={companyChoose}
                              defaultValue={{
                                value: formDataCompanyChoose.companyId,
                                label:
                                  formDataCompanyChoose.companyName +
                                  "-" +
                                  formDataCompanyChoose.companyType,
                              }}
                              onChange={handleCompanyChanges}
                            />
                          </div>
                        </div>

                        <div className="col-md-3">
                          {filteredArray && (
                            <div className="mb-3">
                              <label className="form-label">
                                Lead Form<span className="text-danger"> *</span>
                              </label>
                              <CommonSelect
                                className="select"
                                options={filteredArray}
                                defaultValue={{
                                  value: formSelectDataChoose.id,
                                  label: formSelectDataChoose.leadFormName,
                                }}
                                onChange={handleFilterFormChange}
                              />
                            </div>
                          )}
                        </div>
                        <div className="col-md-3">
                          {filteredArrayPiepline && (
                            <div className="mb-3">
                              <label className="form-label">Pipeline</label>
                              <CommonSelect
                                className="select"
                                options={filteredArrayPiepline}
                                defaultValue={{
                                  value: formSelectDataChoosePipeline.id,
                                  label:
                                    formSelectDataChoosePipeline.pipelineName,
                                }}
                                onChange={handleCompanyChangesPipeline}
                              />
                            </div>
                          )}
                        </div>
                        <div className="col-md-3">
                          {filteredArray && (
                            <div className="mb-3">
                              <label className="form-label">
                                Lead Source{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <select
                                className="form-control"
                                name="parent"
                                value={leadSourceData.parent}
                                onChange={handleParentChange}>
                                <option value="">Select Parent</option>
                                {leadSource.map((data) => (
                                  <option key={data.value} value={data.value}>
                                    {data.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}
                        </div>
                        {leadSourceData.parent && (
                          <div className="col-md-3">
                            <div className="mb-3">
                              <label className="form-label">
                                Sub-Category{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <select
                                className="form-control"
                                name="child"
                                value={leadSourceData.child}
                                onChange={handleChildChange}>
                                <option value="">Select Sub-Category</option>
                                {childOptions?.map((data) => (
                                  <option key={data.value} value={data.value}>
                                    {data.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="row">
                        {filteredFormList &&
                          csvData.length == 0 &&
                          filteredFormList[0].structure.map(
                            (field: FormField) => (
                              <div
                                className={
                                  field.type === "country"
                                    ? "col-md-12"
                                    : "col-md-6"
                                }
                                key={field.id}>
                                <Box sx={{ mb: 2 }}>
                                  {field.type === "text" ? (
                                    <FormControl fullWidth size="small">
                                      <label className="form-label">
                                        {field.label}{" "}
                                        <span
                                          className={
                                            field.required ? "text-danger" : ""
                                          }>
                                          {" "}
                                          {field.required ? " *" : ""}
                                        </span>
                                      </label>
                                      <TextField
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        required={!!field.required}
                                        placeholder={"Enter " + field.label}
                                        onChange={(e) =>
                                          setResponses({
                                            ...responses,
                                            [field.label]: e.target.value,
                                          })
                                        }
                                      />
                                    </FormControl>
                                  ) : field.type === "tel" ? (
                                    <FormControl fullWidth size="small">
                                      <div className="row">
                                        <div className="col-md-3">
                                          <label className="form-label">
                                            {"Code"}{" "}
                                            <span
                                              className={
                                                field.required
                                                  ? "text-danger"
                                                  : ""
                                              }>
                                              {" "}
                                              {field.required ? " *" : ""}
                                            </span>
                                          </label>
                                          <TextField
                                            fullWidth
                                            size="small"
                                            type="number"
                                            variant="outlined"
                                            placeholder="+91"
                                            required={!!field.required}
                                            disabled
                                          />
                                        </div>
                                        <div className="col-md-9">
                                          <label className="form-label">
                                            {field.label}{" "}
                                            <span
                                              className={
                                                field.required
                                                  ? "text-danger"
                                                  : ""
                                              }>
                                              {" "}
                                              {field.required ? " *" : ""}
                                            </span>
                                          </label>
                                          <TextField
                                            fullWidth
                                            size="small"
                                            type="tel"
                                            variant="outlined"
                                            required={!!field.required}
                                            placeholder="Enter 10-digit mobile number"
                                            inputProps={{
                                              maxLength: 10,
                                              inputMode: "numeric",
                                              pattern: "[0-9]*",
                                            }}
                                            //value={responses[field.label] || ""}
                                            onChange={(e) => {
                                              const value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  ""
                                                ); // Remove non-digit characters
                                              if (value.length <= 10) {
                                                setResponses({
                                                  ...responses,
                                                  [field.label]: value,
                                                });
                                              }
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </FormControl>
                                  ) : field.type === "select" ? (
                                    <FormControl fullWidth size="small">
                                      <label className="form-label">
                                        {field.label}
                                        <span
                                          className={
                                            field.required ? "text-danger" : ""
                                          }>
                                          {" "}
                                          {field.required ? " *" : ""}
                                        </span>
                                      </label>
                                      <Select
                                        multiple
                                        required={!!field.required}
                                        MenuProps={{
                                          disableEnforceFocus: true,
                                        }}
                                        value={
                                          responses[field.label]
                                            ? responses[field.label].split(",")
                                            : []
                                        }
                                        onChange={(e) => {
                                          const selectedValues = e.target.value;
                                          const updatedValue =
                                            selectedValues.length > 0
                                              ? selectedValues.join(",")
                                              : "";
                                          setResponses({
                                            ...responses,
                                            [field.label]: updatedValue,
                                          });
                                        }}
                                        renderValue={(selected) =>
                                          selected.join(", ")
                                        }>
                                        {field.options?.map((option, index) => (
                                          <MenuItem key={index} value={option}>
                                            <Checkbox
                                              checked={
                                                responses[field.label]
                                                  ?.split(",")
                                                  .includes(option) || false
                                              }
                                            />
                                            {option}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  ) : field.type === "date" ? (
                                    <FormControl fullWidth size="small">
                                      <label className="form-label">
                                        {field.label}{" "}
                                        <span
                                          className={
                                            field.required ? "text-danger" : ""
                                          }>
                                          {" "}
                                          {field.required ? " *" : ""}
                                        </span>
                                      </label>
                                      <TextField
                                        fullWidth
                                        required={!!field.required}
                                        size="small"
                                        variant="outlined"
                                        onChange={(e) =>
                                          setResponses({
                                            ...responses,
                                            [field.label]: e.target.value,
                                          })
                                        }
                                        type="date"
                                      />
                                    </FormControl>
                                  ) : field.type === "country" ? (
                                    <FormControl fullWidth size="small">
                                      <label className="form-label">
                                        {field.label}
                                        <span
                                          className={
                                            field.required ? "text-danger" : ""
                                          }>
                                          {" "}
                                          {field.required ? " *" : ""}
                                        </span>
                                      </label>
                                      <div className="row">
                                        <div className="col-md-3">
                                          <div className="mb-3">
                                            <label className="">Country </label>
                                            <select
                                              required={!!field.required}
                                              className="form-control"
                                              name="country"
                                              value={selectedCountry}
                                              onChange={handleCountryChange}>
                                              <option value="">Select</option>
                                              {countries.map((country) => (
                                                <option
                                                  key={country.id}
                                                  value={
                                                    country.name +
                                                    "-" +
                                                    country.id
                                                  }>
                                                  {country.name}
                                                </option>
                                              ))}
                                            </select>
                                          </div>
                                        </div>

                                        {/* State */}
                                        <div className="col-md-3">
                                          <div className="mb-3">
                                            <label className="">State </label>
                                            <select
                                              required={!!field.required}
                                              className="form-control"
                                              name="state"
                                              onChange={handleStateChange}
                                              disabled={states.length == 0}>
                                              <option value="">Select</option>
                                              {states.map((state) => (
                                                <option
                                                  key={state.id}
                                                  value={
                                                    state.name + "-" + state.id
                                                  }>
                                                  {state.name}
                                                </option>
                                              ))}
                                            </select>
                                          </div>
                                        </div>

                                        {/* District */}
                                        <div className="col-md-3">
                                          <div className="mb-3">
                                            <label className="">
                                              District{" "}
                                            </label>
                                            <select
                                              required={!!field.required}
                                              className="form-control"
                                              name="city"
                                              onChange={handleDistChange}
                                              disabled={districts.length == 0}>
                                              <option value="">Select</option>
                                              {districts.map((dist) => (
                                                <option
                                                  key={dist.id}
                                                  value={
                                                    dist.district +
                                                    "-" +
                                                    dist.id
                                                  }>
                                                  {dist.district}
                                                </option>
                                              ))}
                                            </select>
                                          </div>
                                        </div>

                                        {/* City */}
                                        <div className="col-md-3">
                                          <div className="mb-3">
                                            <label className="">City </label>
                                            <select
                                              required={!!field.required}
                                              className="form-control"
                                              name="city"
                                              onChange={handleCityChange}
                                              disabled={cities.length == 0}>
                                              <option value="">Select</option>
                                              {cities.map((city) => (
                                                <option
                                                  key={city.id}
                                                  value={
                                                    city.name + "-" + city.id
                                                  }>
                                                  {city.name}
                                                </option>
                                              ))}
                                            </select>
                                          </div>
                                        </div>
                                      </div>
                                    </FormControl>
                                  ) : null}
                                </Box>
                              </div>
                            )
                          )}
                        {filteredFormList &&
                          user?.userDetails.menu_items.includes(
                            "Leads In Queue"
                          ) && (
                            <div className="col-md-6">
                              <FormControl component="fieldset">
                                <label className="form-label">
                                  Assigned Lead
                                </label>
                                <RadioGroup
                                  row
                                  value={assignedLeadType}
                                  onChange={(e) =>
                                    setAssignedLeadType(e.target.value)
                                  }>
                                  <FormControlLabel
                                    value="Automatic"
                                    control={<Radio />}
                                    label="Automatic"
                                  />
                                  <FormControlLabel
                                    value="Manual"
                                    control={<Radio />}
                                    label="Manual"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </div>
                          )}

                        {filteredFormList &&
                          user?.userDetails.menu_items.includes(
                            "Leads In Queue"
                          ) &&
                          assignedLeadType == "Manual" && (
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Assigned To
                                </label>
                                <CommonSelect
                                  className="select"
                                  options={filteredUsers}
                                  defaultValue={{
                                    value: formSelectDataChooseEmployee.id,
                                    label: formSelectDataChooseEmployee.Name,
                                  }}
                                  onChange={handleCompanyChangesEmployee}
                                />
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                    <div className="modal-footer">
                      {filteredFormList && (
                        <h6 className="fw-medium fs-14">
                          <Link
                            to="#"
                            onClick={(e: any) => {
                              e.preventDefault();
                              handleExportExcel();
                            }}>
                            <i className="ti ti-download"></i> Download CSV
                            Sheet
                          </Link>
                        </h6>
                      )}
                      {filteredFormList && (
                        <div className="modal-body pb-0">
                          <div className="row">
                            <div className="mb-3">
                              <input
                                type="file"
                                accept=".csv"
                                onChange={handleFileUpload}
                                ref={fileInputRef}
                              />
                              {csvData.length > 0 && (
                                <div className="mt-2">
                                  <button
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={handleRemoveFile}
                                    type="button">
                                    Remove File
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                      <button
                        type="button"
                        className="btn btn-light me-2"
                        data-bs-dismiss="modal"
                        onClick={() => {
                          setformSelectDataChoose({ leadFormName: "", id: "" });
                          setfilteredFormList(null);
                          refreshPage("cancel");
                          setCsvData([]);
                        }}>
                        Cancel
                      </button>
                      {csvData.length > 0 ? (
                        <Button
                          type="button"
                          className="btn btn-primary"
                          onClick={uploadCsvData}
                          disabled={isUploading}>
                          {isUploading
                            ? "Uploading..."
                            : "Upload Leads from CSV"}
                        </Button>
                      ) : formSelectDataChoose.id !== "" ? (
                        <button
                          type="button"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            handleSubmit();
                          }}
                          className="btn btn-primary">
                          Add Lead
                        </button>
                      ) : null}
                    </div>
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>

        {filteredData.length > 0 && (
          <div className="modal fade">
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                <div className="card">
                  <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                    <h5>Duplicate Leads</h5>
                  </div>
                  <div className="card-body p-0">
                    <Table
                      key={JSON.stringify(filteredData)}
                      dataSource={filteredData}
                      columns={columns}
                      Selection={false}
                    />
                  </div>
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      setformSelectDataChoose({ leadFormName: "", id: "" });
                      setfilteredFormList(null);
                      setFilteredData([]);
                      refreshPage("cancel");
                      setCsvData([]);
                    }}>
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    </>
  );
};

export default AddLeads;
